import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    ImgContainer: {
        position: 'relative',
        '& img': {
            position: "absolute",
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        }
    }
}));

function LazyImg(props) {
    const classes = useStyles();
    const [loaded, setLoaded] = useState(false)
    
    const {placeholder, srcSet="", sizes="", alt=""} = props
    const properProps = Object.assign({}, props)
    delete properProps['placeholder']
    delete properProps['srcSet']
    delete properProps['sizes']
    
    return (
        <div className={classes.ImgContainer}>
            <img 
                src={placeholder}
                loading="eager"
                style={{visibility: !loaded ? "visible" : "hidden"}}
                alt={alt}
                {...(properProps)}
            />
            <img 
                style={{visibility: loaded ? "visible" : "hidden"}}
                srcSet={srcSet}
                sizes={sizes}
                alt={alt}
                {...(properProps)} 
                onLoad={() => setLoaded(true)}
            />
        </div>
    )
}

export default LazyImg